"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var goToSleepMode_1 = __importDefault(require("../actions/playback/goToSleepMode"));
function checkSleepStateSchedule(dispatch, getState) {
    var state = getState();
    var lastSleepCheck = state.global.lastSleepCheck;
    if (lastSleepCheck && Date.now() - lastSleepCheck < 10000) {
        return;
    }
    dispatch((0, goToSleepMode_1.default)());
}
exports.default = checkSleepStateSchedule;
//# sourceMappingURL=checkSleepState.js.map